<template>
  <a-modal
    :visible="visible"
    destroy-on-close
    title="租户信息"
    @cancel="handleCancel"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
    >
      <a-form-model-item
        label="租户ID"
        prop="id"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <span>{{ form.id }}</span>
      </a-form-model-item>
      <a-form-model-item
        label="租户号"
        prop="tenantCode"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <span>{{ form.tenantCode }}</span>
      </a-form-model-item>
      <a-form-model-item
        label="租户全称"
        prop="fullName"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <span>{{ form.fullName }}</span>
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="handleOk">确认</a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex';
import { apiGetTenantDetail } from '@/apis/user';

export default {
  name: 'TenantDetail',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        id: '',
        tenantCode: '',
        fullName: '',
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getTenantDetail();
      }
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  methods: {
    // 获取租户详情信息
    getTenantDetail() {
      apiGetTenantDetail({ tenantId: this.userInfo.source_id }).then(res => {
        this.form = res || {};
      }).catch(err => {
        console.error('获取租户详情失败', err);
      });
    },
    // 点击确认
    handleOk() {
      this.handleCancel();
    },
    // 点击取消
    handleCancel() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="less" scoped>

</style>
